const subscriptions = {};
export function subscribe(name, value) {
    if (subscriptions[name] === undefined) {
        subscriptions[name] = [];
    }
    subscriptions[name].push(value);
    return () => {
        if (subscriptions[name]) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            subscriptions[name] = subscriptions[name].filter((s) => s !== value);
            if (subscriptions[name].length === 0) {
                delete subscriptions[name];
            }
        }
    };
}
export function publish(name, payload) {
    subscriptions[name]?.forEach((sub) => sub(payload));
}
